import React, { useRef } from 'react'
import MainLayout from '../../components/layouts/main-layout'
import Header from '../../components/layouts/header/header'
import DictionarySearchBar from '../../components/search/dictionary-search-bar'
import useTranslationForm from '../../hooks/useTranslationForm'
import { blogIndex } from '../../components/blog/posts'
// Renders in the server HTML, so it's a static import — see main-layout.tsx
// for why lazy() costs a flash of unstyled content here.
import BlogIndex from '../../components/blog/blog-index'

// The /blog landing page. The individual posts live at /blog/$blogSlug (see
// pages/blog/[blog-slug].tsx); the older plain-HTML articles are under /learn
// and aren't listed here — they carry no date, category or illustration.
const BlogIndexPage = () => {
   const textareaRef = useRef<HTMLTextAreaElement | null>(null)
   const { onSubmit, resetForm, control, register } = useTranslationForm(textareaRef)

   return (
      <MainLayout>
         <Header
            compact
            onClick={resetForm}
            onModalClose={() => {
               onSubmit()
            }}
         >
            <DictionarySearchBar
               register={register}
               control={control}
               onSubmit={onSubmit}
               onClear={resetForm}
               textareaRef={textareaRef}
            />
         </Header>
         <BlogIndex posts={blogIndex} />
      </MainLayout>
   )
}

export default BlogIndexPage
